
var geoLocationOptions = {
    enableHighAccuracy: false,
    timeout: 3000,
    maximumAge: 0
};

function debugGeoLocationSuccess(position) {
    var coordinates = position.coords;

    console.log('Your current position is:');
    console.log(`Latitude : ${coordinates.latitude}`);
    console.log(`Longitude: ${coordinates.longitude}`);
    console.log(`More or less ${coordinates.accuracy} meters.`);
}

function fillGeoLocationElements(position, forceReplace) {

    if (forceReplace === undefined) {
        forceReplace = false;
    }

    //if they already accepted (by having the cookie), and force replace is false, its implied they allowed their location but refreshed the page
    if (getCookie("geolocationCoords") !== null && !forceReplace) {
        //skip the op
        return;
    }

    if (getCookie("geolocationCoords") === null || forceReplace) {
        var prefillText = String.format("{0}, {1}", position.coords.latitude, position.coords.longitude);
        var submitFormElement;

        $('[data-geolocation-fill-location]').each(function () {
            if ($(this).is('input')) {

                if (!$(this).val() || forceReplace) {
                    $(this).val(prefillText);

                    if ($(this).attr('data-geolocation-fill-mask')) {
                        var maskElement = $('#' + $(this).attr('data-geolocation-fill-mask'));
                        $(maskElement).show();
                        $(this).attr('readonly', true);
                        $(this).addClass("masked-input");
                    }

                    if ($(this).attr('data-geolocation-fill-location') === "submit") {
                        submitFormElement = $(this);
                    }
                }
            }
            else {
                $(this).text(prefillText);
            }
        });

        if (submitFormElement && submitFormElement.length) {
            $(submitFormElement).closest('form').submit();
        }
    }
}

function geoLocationError(error) {
    console.debug(`GEOLOCATION ERROR(${error.code}): ${error.message}`);

    $('[data-geolocation-trigger]').each(function () {
        //$(this).hide();

        var errorTargetId = $(this).attr('data-geolocation-error-element');
        var errorTargetElement = $(errorTargetId);

        if (errorTargetElement.length) {
            $(errorTargetElement).show();
        }
    });

    deleteCookie('geolocationCoords');

    //switch (error.code) {
    //    case error.PERMISSION_DENIED:
    //        console.debug("User denied the request for Geolocation.");
    //        break;
    //    case error.POSITION_UNAVAILABLE:
    //        console.debug("Location information is unavailable.");
    //        break;
    //    case error.TIMEOUT:
    //        console.debug("The request to get user location timed out.");
    //        break;
    //    case error.UNKNOWN_ERROR:
    //        console.debug("An unknown error occurred during geolocation.");
    //        break;
    //}
}

function hideGeoLocationErrors() {
    $('.geolocation-error').hide();
}

function getLocation(forceReplace) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            //debugGeoLocationSuccess(position);
            hideGeoLocationErrors();
            fillGeoLocationElements(position, forceReplace);
            setGeoCookie(position);
            return true;

        }, geoLocationError, geoLocationOptions);
    }

    return false;
}

window.setGeoCookie = function setGeoCookie(position) {
    var cookie_val = position.coords.latitude + "---" + position.coords.longitude;
    var now = new Date();
    now.setTime(now.getTime() + 1 * 3600 * 1000);
    document.cookie = "geolocationCoords=" + escape(cookie_val) + "; expires=" + now.toUTCString() + "; path=/";
}

$(document).ready(function () {
    //getLocation(false);
});

$('[data-geolocation-trigger]').on('click', function () {
    getLocation(true);
});